import React, { useRef } from 'react';
import { Box, Button, IconButton, Input } from '@wix/design-system';
import { DismissSmall, SparklesFilledSmall } from '@wix/wix-ui-icons-common/lazy';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import s from './BngSearchField.scss';
const PADDING_UNIT_MULTIPLIER = 4; /* --wds-space-100 */
const INPUT_HEIGHT_SMALL = 30; /* --wds-button-size-small */
const ROW_PADDING = 3; // px — vertical padding inside the search field row

export const BngSearchField = _ref => {
  let value = _ref.value,
    onChange = _ref.onChange,
    onSubmit = _ref.onSubmit,
    _ref$outline = _ref.outline,
    outline = _ref$outline === void 0 ? 'standard' : _ref$outline;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const trimmedValue = value.trim();
  const inputRef = useRef(null);
  const onClear = () => {
    var _inputRef$current;
    onChange('');
    (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
  };
  return /*#__PURE__*/React.createElement(Box, {
    className: s.row,
    borderColor: outline === 'light' ? 'var(--wds-color-border-standard-tertiary)' : undefined,
    align: "center",
    gap: 12,
    width: "100%",
    height: INPUT_HEIGHT_SMALL + ROW_PADDING * PADDING_UNIT_MULTIPLIER * 2,
    padding: ROW_PADDING,
    boxSizing: "border-box",
    borderRadius: 6
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    height: "100%",
    padding: "0 12px 0 0",
    boxSizing: "border-box",
    flex: 1,
    minWidth: 0,
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    className: s.input,
    value: value,
    onChange: e => onChange(e.target.value),
    placeholder: t('domain_search_gate.bng_results.search_bar.placeholder'),
    ariaLabel: t('domain_search_gate.bng_results.search_bar.placeholder'),
    onEnterPressed: onSubmit
  })), /*#__PURE__*/React.createElement(Box, {
    className: s.actions,
    align: "center",
    gap: 4
  }, trimmedValue && /*#__PURE__*/React.createElement(IconButton, {
    className: s.clearButton,
    skin: "dark",
    priority: "tertiary",
    size: "small",
    "aria-label": t('domain_search_gate.bng_results.search_bar.clear_input'),
    onClick: onClear
  }, /*#__PURE__*/React.createElement(DismissSmall, null)), /*#__PURE__*/React.createElement(Button, {
    className: s.submitButton,
    skin: "dark",
    size: "small",
    prefixIcon: /*#__PURE__*/React.createElement(SparklesFilledSmall, null),
    disabled: !trimmedValue,
    onClick: onSubmit
  }, t('domain_search_gate.bng_results.search_bar.generate_cta'))));
};
//# sourceMappingURL=BngSearchField.js.map